import { render, staticRenderFns } from "./OrientacoesPage.vue?vue&type=template&id=efc08f6e"
import script from "./OrientacoesPage.vue?vue&type=script&lang=js"
export * from "./OrientacoesPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports